import * as React from "react";
const SvgVersion20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M16.086 6H11.98l-3.2 4 3.2 4h4.105l-1.793-1.793 1.414-1.414L19.914 15l-4.207 4.207-1.414-1.414L16.086 16H11.98a2 2 0 0 1-1.562-.75L7.019 11H.5V9h6.52l3.399-4.25A2 2 0 0 1 11.98 4h4.105l-1.793-1.793L15.707.793 19.914 5l-4.207 4.207-1.414-1.414L16.086 6Z",
      clipRule: "evenodd"
    })
  );
export default SvgVersion20Px;
